import styled from 'styled-components'
import { colors } from '../../../util/StellaConstant'

export const EventScheduleStyled = styled.div`
    background-color: ${colors.white};
    box-shadow: 0 1px 3px 0 ${colors.oxfordBlue};
    border-radius: 4px;
    padding: 60px 11px 21px 20px;
    margin-bottom: 11px;
`